<!-- List popup -->
<template>
	<div
		class="modal fade"
		id="exactHistoryDescPopup"
		tabindex="-1"
		role="dialog"
		aria-labelledby="openModal"
		aria-hidden="true"
		data-backdrop="static"
	>
		<div class="modal-dialog modal-lg" role="document">
			<div
				class="modal-content campaign-g-addedit"
				style="width:1000px;height:260px;margin-left:-49px"
			>
				<div class="modal-header" style = "flex: 0 0 auto">
					<h5 class="modal-title" id="exampleModalLongTitle">{{'Search Term Performance'}}</h5>
					<button type="button" class="close" data-dismiss="modal">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body" v-if="showSpinner">
					<div class="spinner-border" style="margin:auto;display:block"></div>
				</div>

				<div class="modal-body" style="font-size:14px" v-else-if="!showSpinner && descArray.length">
					<table class="table">
						<thead>
							<tr>
								<th>Original keyword</th>
								<th>Match Type</th>
								<th>Clicks</th>
								<th>Cost</th>
								<th>Ad Group</th>
                                <th>Impressions</th>
                                <th>Pull Time</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in (descArray)" :key="item +'_'+ index">
								<td>{{item.keyword_text}}</td>
								<td>{{(item.match_type)}}</td>
								<td>{{item.clicks}}</td>
                                <td>{{item.sales}}</td>
								<td>{{item.ad_group}}</td>
                                <td>{{item.impressions}}</td>
                                <td style="width:20%">{{getDateTime(item.pull_timestamp)}}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="modal-body" v-else>
					<p class="ml-1">No items to display.</p>
				</div>
				<div class="modal-footer" style = "flex: 0 0 auto">
					<div style="text-align: center">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
var moment = require("moment");
	export default {
		name: "ExactTypeHistoryPopUp",
		data() {
			return {};
		},
		components:{
		},
		props: ["showSpinner", 'descArray'],
		methods: {
			moment,
			getDateTime(data){
				return moment(data).utc().format("YYYY-MM-DD hh:mm A")
			},
			openPopUp() {
				$("#exactHistoryDescPopup").modal("show");
			},
			resetPagination(){
				this.$emit('resetPagination')
			}
		}
	};
</script>

<style>
.scroll {
	min-height: 350px !important;
	overflow: auto;
}
</style>
